import axios from "axios";

export const fetchModules = async () => {
    const response = await axios.get("api/modules/");
    const modules = response.data;
    return modules;
}